/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Vs_Yaml_Xml_S4_P2Inputs */

const en_guide_json_vs_yaml_xml_s4_p2 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S4_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XML's verbosity is its biggest drawback: tags add significant overhead compared to JSON. An XML document is typically 2-3x larger than the equivalent JSON, impacting transfer speed and storage.`)
};

const ko_guide_json_vs_yaml_xml_s4_p2 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S4_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XML의 장황함이 가장 큰 단점입니다: 태그가 JSON에 비해 상당한 오버헤드를 추가합니다. XML 문서는 일반적으로 동등한 JSON보다 2-3배 크기 때문에 전송 속도와 저장 공간에 영향을 미칩니다.`)
};

const ja_guide_json_vs_yaml_xml_s4_p2 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S4_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XMLの冗長性が最大の欠点です: タグはJSONと比較して大きなオーバーヘッドを追加します。XMLドキュメントは通常、同等のJSONの2〜3倍の大きさになり、転送速度やストレージに影響を与えます。`)
};

/**
* | output |
* | --- |
* | "XML's verbosity is its biggest drawback: tags add significant overhead compared to JSON. An XML document is typically 2-3x larger than the equivalent JSON, i..." |
*
* @param {Guide_Json_Vs_Yaml_Xml_S4_P2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_vs_yaml_xml_s4_p2 = /** @type {((inputs?: Guide_Json_Vs_Yaml_Xml_S4_P2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Vs_Yaml_Xml_S4_P2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_vs_yaml_xml_s4_p2(inputs)
	if (locale === "ko") return ko_guide_json_vs_yaml_xml_s4_p2(inputs)
	return ja_guide_json_vs_yaml_xml_s4_p2(inputs)
});